import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormModalBaseComponent } from '../../../../../../../core/base/components/form-modal-base/form-modal-base.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { BuildingService } from '../../../building.service';
import { SnackbarService } from '../../../../../../../core/services/snackbar.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BuildingModel } from '../../../../../../../core/models/building.model';
import { FormModalConfirmBaseComponent } from '../../../../../../../core/base/components/form-modal-confirme-base/form-modal-confirm-base.component';
import { MetrikStatusModuleEnum } from '../../../../../../../core/enums/metrik-status.enum';
import { getCurrentAndNextStatus } from '../../../../../../../core/utils/metrikStatus-utils';
import { Observable } from 'rxjs';
import { BuildingMetrikStatusModel } from '../../../../../../../core/models/building-metrik-status.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'vex-building-metrik-status',
  templateUrl: './building-metrik-status.component.html',
  styleUrls: [
    './building-metrik-status.component.scss',
    '../../../../../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../../../../../@vex/styles/partials/plugins/_quill.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class BuildingMetrikStatusComponent extends FormModalBaseComponent<BuildingModel> implements OnInit {
  readonly MetrikStatusModuleEnum = MetrikStatusModuleEnum;
  buildingMetrikStatus$: Observable<BuildingMetrikStatusModel[]>;
  metrik: BuildingMetrikStatusModel;
  isBuildingActive = true;
  private isSubmitting = false;

  customModule = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      ['clean'],
      ['link'],
    ],
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FormModalBaseComponent<BuildingModel>>,
    public dialog: MatDialog,
    public service: BuildingService,
    public snackbarService: SnackbarService,
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit(): void {
    this.defaults = this.data?.building;
    this.metrik = this.data?.metrik;
    console.log(this.data, 'voici la data');
    this.isBuildingActive = this.computeIsActive(this.defaults?.metrikStatus ?? []);
    this.getBuildingMetrikStatus();
    this.initForm();
  }

  initForm() {
    if (this.data.isForMetrikStatus) {
      console.log('metrik status');
      this.form = new UntypedFormGroup({
        _id: new UntypedFormControl(null),
        genericMetrikStatus: new UntypedFormControl(null, [Validators.required]),
        startDate: new UntypedFormControl(null, [Validators.required]),
        endDate: new UntypedFormControl(null),
        comment: new UntypedFormControl(null, [Validators.required]),
      });
    } else {
      console.log('problemos date fin');
      // si ajout d'une date de fin de service
      this.form = new UntypedFormGroup({
        _id: new UntypedFormControl(this.defaults?._id),
        //     genericMetrikStatus: new FormControl(null, [Validators.required]),
        startDate: new UntypedFormControl(null, [Validators.required]),
        //     endDate: new FormControl(null),
        comment: new UntypedFormControl(null, [Validators.required]),
      });
    }
  }

  private computeIsActive(metrikStatus: any[]): boolean {
    const [current] = getCurrentAndNextStatus(metrikStatus as any);
    if (!current) {
      return true;
    }
    if ((current as any).isDefinitivelyOver) {
      return false;
    }
    return (current as any).isSystem ?? true;
  }

  getBuildingMetrikStatus() {
    this.buildingMetrikStatus$ = this.service.findAll(null, null, 'startDate', 'desc').pipe(map((x: any) => x.data));
  }

  createItem(): void {
    if (this.isSubmitting) {
      return;
    }
    this.loading = true;
    const { genericMetrikStatus, ...rest } = this.form.getRawValue();
    const buildingMetrik = {
      genericMetrikStatusId: genericMetrikStatus._id,
      ...rest,
    };
    this.beforeCreateItem();
    if (this.form.valid) {
      this.isSubmitting = true;
      const sub = this.service.createMetrik(this.defaults._id, buildingMetrik).subscribe(
        result => {
          this.close(result.data);
          this.snackbarService.success("L'état du bâtiment a été mis à jour avec succès.");
          this.afterCreateItem(result, null);
        },
        error => {
          this.afterCreateItem(null, error);
          this.setErrorsMessages(error.error.errors);
          this.loading = false;
          this.isSubmitting = false;
        },
      );
      this.subscription.add(sub);
    } else {
      this.onFormInvalid();
      this.logFormErrors(this.form);
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  setEndServiceDate(): void {
    if (this.isSubmitting) {
      return;
    }

    // 🔹 **Activation des validateurs et validation AVANT d'afficher la modale**
    this.form.controls.startDate.setValidators([Validators.required]);
    this.form.controls.comment.setValidators([Validators.required]);
    this.form.controls.startDate.updateValueAndValidity();
    this.form.controls.comment.updateValueAndValidity();

    if (!this.form.valid) {
      this.logFormErrors(this.form);
      this.form.markAllAsTouched();
      return;
    }

    // 🔹 **Vérification des dépendances avant confirmation**
    this.loading = true;
    this.service.checkDependencies(this.defaults).subscribe(
      response => {
        this.loading = false;
        const dependencies = response.data;

        // Construire le message de confirmation avec les dépendances
        let confirmMessage = `Voulez-vous vraiment rendre ce bâtiment définitivement inactif ? Cette action est irréversible.\n\n`;

        // Ajouter les impacts si des dépendances existent
        if (dependencies.details) {
          if (dependencies.details.eshopBaskets && dependencies.details.eshopBaskets.length > 0) {
            confirmMessage += `\n Les articles et prestations contenus dans les paniers ci-dessous auront définitivement le statut "Retiré" :\n`;
            confirmMessage += dependencies.details.eshopBaskets
              .map((b: any) => `  • ${b.technicalIdentifier}`)
              .join('\n');
            confirmMessage += `\n`;
          }

          if (dependencies.details.equipments && dependencies.details.equipments.length > 0) {
            confirmMessage += `\n📍 Les équipements abrités dans ce bâtiment et listés ci-dessous n'auront plus d'emplacement renseigné :\n`;
            confirmMessage += dependencies.details.equipments
              .map((e: any) => `  • ${e.technicalIdentifier || e.reference}`)
              .join('\n');
            confirmMessage += `\n`;
          }

          if (dependencies.details.contracts && dependencies.details.contracts.length > 0) {
            confirmMessage += `\n📋 Le bâtiment ne sera plus couvert par le(s) contrat(s) ci-dessous dès signature(s) d'avenant(s) :\n`;
            confirmMessage += dependencies.details.contracts
              .map((c: any) => `  • ${c.technicalIdentifier}${c.object ? ' - ' + c.object : ''}`)
              .join('\n');
          }
        }

        // 🔹 **Affichage de la modale de confirmation après validation**
        this.dialog
          .open(FormModalConfirmBaseComponent, {
            data: {
              title: 'Confirmation de fin de service',
              message: confirmMessage,
            },
            width: '600px',
          })
          .afterClosed()
          .subscribe((confirmed: boolean) => {
            if (!confirmed) {
              return;
            }
            this.processEndServiceDate();
          });
      },
      error => {
        this.loading = false;
        this.snackbarService.danger('Erreur lors de la vérification des dépendances');
      },
    );
  }

  /**
   * Exécute la requête de mise à jour après confirmation.
   */
  private processEndServiceDate(): void {
    this.loading = true;
    this.isSubmitting = true;

    const sub = this.service.setEndServiceDate(this.defaults._id, this.form.getRawValue()).subscribe(
      result => {
        this.close(result.data);
        this.snackbarService.success("L'état du bâtiment a été mis à jour avec succès.");
        this.afterCreateItem(result, null);
      },
      error => {
        this.afterCreateItem(null, error);
        this.setErrorsMessages(error.error.errors);
        this.loading = false;
        this.isSubmitting = false;
      },
    );

    this.subscription.add(sub);
  }
}
